"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Separator = require("./Separator");
Object.keys(_Separator).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Separator[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Separator[key];
    }
  });
});